import { useSelector } from 'react-redux';
import TrailDashboard from '../TrailDashboard';
import WCATemplateList from '../WCA/WCAMessageTemplate/TemplateList';
import TemplateList from '../MessageTemplates/TemplateList';

const CampaignTemplateList = () => {
  const { userSub, companyConfigData } = useSelector((state) => state.authenticate);
  if (!userSub?.isUserSub) {
    return <TrailDashboard />;
  }

  return companyConfigData?.wabaPartner === 'skalebot' ? <WCATemplateList /> : <TemplateList />;
};

export default CampaignTemplateList;
